import styled from 'styled-components';

export const H2 = styled.h2`
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
    margin: 8px 0;
`;

export const H3 = styled.h3`
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin: 0;
`;

export const H4 = styled.h4`
    font-size: 14px;
`;

export const HelperText = styled.label`
    font-size: 14px;
    opacity: 0.85;
    cursor: pointer;
    margin-left: 30px;
`;

export const StyledFormGroupContainer = styled.div`
    margin-left: 10px;
    margin-bottom: 28px;
`;
